import React from 'react';
import { Card } from './ui/card';
import { TrendingUp } from 'lucide-react';

const About = ({ data }) => {
  return (
    <section id="about" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl animate-pulse" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            {/* Profile Photo - Takes 2 columns */}
            <div className="md:col-span-2 flex justify-center">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-yellow-500 rounded-2xl blur-2xl opacity-40 group-hover:opacity-60 transition-opacity duration-500" />
                <div className="relative w-full max-w-sm aspect-square rounded-2xl overflow-hidden border-4 border-emerald-500/30 shadow-2xl shadow-emerald-500/20 group-hover:scale-105 transition-transform duration-500">
                  <img
                    src={data.profileImage}
                    alt={data.title}
                    className="w-full h-full object-cover object-center"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=600&h=600&fit=crop';
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Content - Takes 3 columns */}
            <div className="md:col-span-3 space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-white">
                <span className="bg-gradient-to-r from-emerald-400 to-yellow-500 bg-clip-text text-transparent">
                  About
                </span>
                {' '}Me
              </h2>
              <h3 className="text-2xl font-semibold text-white">{data.title}</h3>
              <p className="text-slate-400 text-base leading-relaxed">{data.description}</p>
              
              {/* Additional Info */}
              <div className="grid grid-cols-2 gap-4 pt-4">
                <div className="space-y-2 group">
                  <p className="text-sm text-slate-500 group-hover:text-emerald-400 transition-colors">Location</p>
                  <p className="text-white font-medium">{data.location}</p>
                </div>
                <div className="space-y-2 group">
                  <p className="text-sm text-slate-500 group-hover:text-emerald-400 transition-colors">Hourly Rate</p>
                  <p className="text-emerald-400 font-medium">{data.hourlyRate}</p>
                </div>
                <div className="space-y-2 group">
                  <p className="text-sm text-slate-500 group-hover:text-emerald-400 transition-colors">Fiverr Status</p>
                  <p className="text-white font-medium">{data.fiverr}</p>
                </div>
                <div className="space-y-2 group">
                  <p className="text-sm text-slate-500 group-hover:text-emerald-400 transition-colors">Languages</p>
                  <p className="text-white font-medium text-sm">{data.languages.slice(0, 2).join(', ')}</p>
                </div>
              </div>
              
              <div className="flex flex-wrap gap-2 pt-4">
                <span className="text-xs text-slate-500 font-medium">All Languages:</span>
                {data.languages.map((lang) => (
                  <span
                    key={lang}
                    className="px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs font-medium hover:scale-110 hover:bg-emerald-500/20 transition-all duration-300"
                  >
                    {lang}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Stats Grid Below */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
            {data.stats.map((stat, index) => (
              <Card
                key={index}
                className="group p-6 bg-slate-900/50 border-slate-800 hover:border-emerald-500/50 transition-all duration-500 hover:shadow-lg hover:shadow-emerald-500/20 backdrop-blur-sm text-center hover:-translate-y-2"
              >
                <TrendingUp className="w-8 h-8 text-emerald-400 mx-auto mb-3 group-hover:scale-125 group-hover:rotate-12 transition-all duration-300" />
                <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-emerald-400 to-yellow-500 bg-clip-text text-transparent mb-2">
                  {stat.value}
                </div>
                <div className="text-slate-400 text-sm font-medium">{stat.label}</div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
